export function isNumberValid(value) {
    var regex = /^-?\d+(\.\d+)?$/;
    return regex.test(value);
}